var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-red color-white addItem"},[_c('center',{staticClass:"color-black"},[_vm._v("DATA")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }